"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class OwnershipModel extends _1.BaseModel {
    static get ROLE_OWNER() { return 'Owner'; } // delete this once apto-desktop has been updated
    static get ROLE() {
        return {
            OWNER: 'Owner',
            FORMER_OWNER: 'Former Owner',
            ASSET_MANAGER: 'Asset Manager',
            PRIMARY_OWNER: 'Primary Owner'
        };
    }
    static splitOwnerships(ownerships) {
        const companyOwnerships = [];
        const contactOwnerships = [];
        if (ownerships && ownerships.length) {
            ownerships.forEach((ownership) => {
                if (ownership.company && !ownership.contact) {
                    companyOwnerships.push(ownership);
                }
                else if (ownership.contact) {
                    contactOwnerships.push(ownership);
                }
            });
        }
        return {
            companyOwnerships,
            contactOwnerships
        };
    }
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            companyId: 'McLabs2__Account_Owner__c',
            companyIdFromTrigger: 'McLabs2__CompanyTrigger__c',
            contactId: 'McLabs2__Contact_Owner__c',
            contactRole: 'McLabs2__Contact_Role__c',
            isPrimaryContact: 'McLabs2__Primary_Contact__c',
            ownerId: 'OwnerId',
            propertyId: 'McLabs2__Property__c'
        };
    }
}
exports.OwnershipModel = OwnershipModel;
//# sourceMappingURL=ownership.model.js.map